/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ConnectApps/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import App from './App/index'
import Apps from './Apps/index'
import Automation from './Automation/index'
import No from './No/index'
import React from 'react'
import Sync from './Sync/index'



/** @type {import('Simple/types.js').View} */
export default function ConnectApps({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let tabSelectedAppIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.app_id',
})
let tabSelectedAutomationIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.automation_id',
})
let tabSelectedSyncIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.sync_id',
})
let aggregateData = fromHelpers.getView(tabSelectedAppIdValueData, tabSelectedAutomationIdValueData, tabSelectedSyncIdValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: aggregateData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Apps'}>
<Apps
  viewPath={`${viewPath}/Apps`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'App'}>
<App
  viewPath={`${viewPath}/App`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Sync'}>
<Sync
  viewPath={`${viewPath}/Sync`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Automation'}>
<Automation
  viewPath={`${viewPath}/Automation`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}